import axios from 'axios'
import {ApiConfig as config} from '@/config'

function parseRatings (response) {
  return response.data.ratings
}

function oneProductRating (ratings) {
  return ratings.length > 0 ? ratings[0] : {}
}

export function getProductRatings (productIds) {
  return new Promise((resolve, reject) => {
    axios.get(`${config.apiUrl}/api/v1/ratings?productIds=${productIds.join(',')}`)
      .then(response => resolve(parseRatings(response)))
      .catch(reject)
  })
}

export function getProductRating (productId) {
  return new Promise((resolve, reject) => {
    getProductRatings([productId])
      .then(ratings => resolve(oneProductRating(ratings)))
      .catch(reject)
  })
}



// WEBPACK FOOTER //
// ./src/api/productReviews/getProductRatings.js